import { useEffect, useRef, useState } from 'react';

import { stayProperties } from '../pages/stayProperties';
const stayLinks = [['All Stays', '/stay'], ...Object.values(stayProperties).map(property => [property.name, property.path])];

export default function StayNavigation({ mobile = false, menuOpen = true, onNavigate }) {
  const [expanded, setExpanded] = useState(false);
  const root = useRef(null);
  const toggle = useRef(null);
  const panel = useRef(null);
  const id = mobile ? 'mobile-stay-links' : 'desktop-stay-links';

  useEffect(() => { if (!menuOpen) setExpanded(false); }, [menuOpen]);
  useEffect(() => {
    if (!expanded) return;
    function outside(event) { if (!root.current.contains(event.target)) setExpanded(false); }
    document.addEventListener('pointerdown', outside);
    return () => document.removeEventListener('pointerdown', outside);
  }, [expanded]);

  function keyDown(event) {
    if (event.key === 'Escape' && expanded) {
      event.stopPropagation();
      setExpanded(false);
      toggle.current.focus();
    }
    if (event.key === 'ArrowDown' && event.target === toggle.current) {
      event.preventDefault();
      setExpanded(true);
      requestAnimationFrame(() => panel.current.querySelector('a').focus());
    }
  }

  return (
    <div className={`site-header__stay${mobile ? ' site-header__stay--mobile' : ''}`} ref={root} onMouseEnter={() => { if (!mobile) setExpanded(true); }} onMouseLeave={() => { if (!mobile) setExpanded(false); }} onKeyDown={keyDown}
      onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) setExpanded(false); }}>
      <div className="site-header__stay-row">
        <a href="/stay" onClick={onNavigate}>Stay</a>
        <button ref={toggle} className="site-header__stay-toggle" type="button" aria-label="Toggle stay destinations" aria-expanded={expanded} aria-controls={id} onClick={() => setExpanded(value => !value)}><svg className="site-header__stay-icon" viewBox="0 0 12 8" aria-hidden="true" focusable="false"><path d="m1 1 5 5 5-5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></svg></button>
      </div>
      <div ref={panel} id={id} className="site-header__stay-panel" hidden={!expanded}>
        {stayLinks.map(([label, href]) => <a key={href} href={href} onClick={() => { setExpanded(false); onNavigate?.(); }}>{label}</a>)}
      </div>
    </div>
  );
}
